import { Link } from 'react-router-dom';
import { Icon } from '@/components/ui/Icon';
import { useAfterOn } from './api';

/** Friends → Dates: the way into My dates (only while after_date is on). */
export function MyDatesLink() {
  const on = useAfterOn();
  if (!on) return null;
  return (
    <Link to="/dates" className="inline-flex h-10 items-center gap-1 rounded-full px-3 text-sm font-semibold text-muted hover:bg-raised hover:text-fg" data-testid="my-dates-link">
      My dates <Icon name="chevron-right" size={16} />
    </Link>
  );
}
